export type Audesp4TermoAditivoJustificativaSim = {
    JustificativaSim: 'S';
    JustificativaApresentada: string;
}

export type Audesp4AutorizacaoAssinaturaSim = {
    AutorizacaoSim: 'S';
    TermoAditivoAutorizacaoDt: string;
}